module.exports = __webpack_public_path__ + "fd4ff709e3581e3f62e40e90260a1ad7.woff2";